// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import MapView from "./components/MapView";
import ListView from "./components/ListView";
/* import SocialApp from "./components/social/SocialApp";
import ProfilePage from './components/social/ProfilePage';
import Notifications from './components/social/Notifications';*/
import Footer from "./components/Footer"; 
import Input from "./components/Input";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App bg-gray-50 min-h-screen">
          <Routes>
            <Route path="/" element={<MapView />} />
            <Route path="/list" element={<ListView />} />
            {/* <Route path="/social/*" element={<SocialApp />} /> */}
           {/*  <Route path="/profile" element={<ProfilePage />} /> */}
            <Route path="/input" element={<Input />} />
            
            {/* <Route path="/notifications" element={<Notifications />} /> */}
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;